export * from './sales-phrase.component';
export * from './sales-phrase-form.component';
